<template>
  <v-card class="base-card shadow">
    <v-card-title class="headline accent--text pb-4"> Комментарий при отклонении работы </v-card-title>

    <v-card-text>
      <CardTextAreaRow
        label="Комментарий"
        :value="comment"
        :readonly="true"
        hide-border-bottom
      />
    </v-card-text>
  </v-card>
</template>

<script>
import CardTextAreaRow from '@/components/ui/row/CardTextAreaRow.vue'

export default {
  components: {
    CardTextAreaRow
  },
  props: {
    comment: String
  }
}
</script>

<style></style>
